import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { statusSelector } from '../features/websocket/websocketSlice';
import { connectToWebSocket } from '../components/WebsocketStatus/WebsocketStatusManager';
import Stepper from '../components/Stepper/Stepper';
import { Icon, Divider } from '@blueprintjs/core';
import TeachRTooltip from "../components/Tooltip/TeachRTooltip"
/* sub pages: */
import ConfigureOptions from '../features/ConfigurationContent/ConfigureOptions';
import ConfigureScenario from '../features/ConfigurationContent/ConfigureScenario';
import ConfigurePresentation from '../features/ConfigurationContent/ConfigurePresentation';
//import ConfigureRoomModules from '../features/ConfigurationContent/ConfigureRoomModules';
import ConfigureDocumentation from '../features/ConfigurationContent/ConfigureDocumentation';
import Heatmap from './Heatmap'
import '../constants/ColorCodes.css';

// available sub-pages as steps of the configuration process
const steps = [
    'Options',
    'Scenario',
    'Presentation',
    //'Room Modules',
    'Help',
    'xAPI storage'
];

/**
 * Configuration page for a session with a vertical stepper that guides through the steps.
 * 
 * @param {function} onNext - Function that is called up when the configuration is completed.
 * @returns {JSX.Element} The rendered `ConfigureSessionPage` component.
 */
const ConfigureSessionPage = ({ onNext }) => {
    const [currentStep, setCurrentStep] = useState(0);
    const status = useSelector(statusSelector);  // Retrieve the WebSocket status from Redux
    const dispatch = useDispatch();

    const tabComponents = {
        0: ConfigureOptions,
        1: ConfigureScenario,
        2: ConfigurePresentation,
/*        3: ConfigureRoomModules,*/
        3: ConfigureDocumentation,
        4: Heatmap
    };

    const ActiveComponent = tabComponents[currentStep];

    /**
     * Changes the current step in the stepper.
     * 
     * @param {number} stepIndex - The index of the new step.
     */
    const handleStepChange = (stepIndex) => {
        setCurrentStep(stepIndex);
    };

    // Monitors the connection status. As soon as the "connected" status is reached, `onNext` is executed.
    useEffect(() => {
        if (status === 'connected') {
            onNext();
        }
    }, [status, onNext]);  // Monitors the connection status and `onNext`.

    const handleConfigFinished = () => {
        console.log("Try to connect with Unity");
        connectToWebSocket(dispatch);
    };

    return (
        <div style={{ height: '100vh', display: 'flex', margin: '0', padding: '0' }}>
            <div style={{ width: '200px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                {/* Tooltip with Info icon */}
                {/*<div style={{ height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', color: 'var(--textcolor)', backgroundColor: 'var(--background)' }}>*/}
                {/*    */}{/*<Icon icon="arrow-down" style={{ margin: '0 5px' }} />*/}
                {/*    */}{/*<p>Configuration progress</p>*/}
                {/*    */}{/*<TeachRTooltip*/}
                {/*    */}{/*    content="You can configure the options below before connecting to the VR."*/}
                {/*    */}{/*    icon="info-sign"*/}
                {/*    */}{/*    iconColor="var(--highlight_1)"*/}
                {/*    */}{/*    tooltipDirection="right"/>*/}
                {/*</div>*/}
                {/*<Divider style={{ backgroundColor: 'var(--gray_1)' }} />*/}
                <Stepper
                    steps={steps}
                    currentStep={currentStep}
                    onStepChange={handleStepChange}
                    orientation='vertical'
                />
            </div>
            <Divider style={{ backgroundColor: 'var(--gray_1)' }} />
            <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0px', color: 'var(--textcolor)', backgroundColor: 'var(--background)' }}>
                    <button
                        style={{
                            height: "32px",
                            font: "20px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "var(--background)",
                            backgroundColor: "var(--select)",
                            border: "3px solid var(--textcolor)",
                            borderColor: "var(--select)",
                            borderRadius: "5px"
                        }}
                        onClick={handleConfigFinished}>Config finished</button>
                </div>
                <Divider style={{ backgroundColor: 'var(--gray_1)' }} />
                <div style={{ flexGrow: 1, padding: '0px' }}>
                    {ActiveComponent && <ActiveComponent />}
                </div>
            </div>
        </div>
    );
};

export default ConfigureSessionPage;
